import React from "react";
import styled, { withTheme } from "styled-components";
import { BodySemiboldStyle } from "storybook-components/Typography";

const MktoWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 32px;
  .mktoForm {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    .mktoFormRow,
    .mktoFormCol,
    .mktoFieldWrap {
      width: 100%;
    }
    .mktoFormRow & input[type="hidden"] {
      margin: 0;
    }
  }
  .mktoForm .mktoFormRow .mktoFieldWrap {
    display: flex;
    flex-direction: column;
    min-height: 45px;
    ${({ theme }) => theme.media.desktopUp`
      flex-direction: row;
    `};
    .mktoLabel {
      ${BodySemiboldStyle}
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
      color: ${({ theme }) => theme.colors.gray1};
      width: 100% !important;
      margin-bottom: 8px;
      ${({ theme }) => theme.media.desktopUp`
        margin-bottom: 0;
        width: 40% !important;
      `};
    }
    .mktoAsterix {
      display: inline-block;
      margin-right: 8px;
      color: ${({ theme }) => theme.colors.gray1};
    }
    .mktoField {
      border: ${({ theme }) => theme.colors.gray400} solid 1px;
      border-radius: 10px;
      font-size: 1.1rem;
      font-family: ${({ theme }) => theme.fonts.graphik};
      padding: 0 8px;
      height: 40px;
      ${({ theme }) => theme.media.desktopUp`
        height: inherit;
        width: 70% !important;
      `};
      &::placeholder {
        color: ${({ theme }) => theme.colors.gray10};
        font-size: 1.1rem;
        line-height: 50px;
      }
      &:active,
      &:focus {
        outline: none;
      }
    }
  }
  .mktoForm .mktoButtonRow .mktoButtonWrap {
    margin: 0 !important;
  }
`;

const MarketoStyleWrapperBase = ({ children }) => (
  <MktoWrapper>{children}</MktoWrapper>
);

export default withTheme(MarketoStyleWrapperBase);
